// extracted by mini-css-extract-plugin
export default {"search-header":"cgTnE","search-header__button":"R6HNn"};